import React, { Component } from 'react'
import SendEmail from '../email/send-email.component'
import Code from '../code/code.component'
import PasswordComponent from '../password/password.component'
import ConfirmPasswordComponent from '../password/confirm-password.component'

import { Formik, Form } from 'formik'
import Yup from '../../../../../helpers/custom-yup'
import { MuvicardService } from '../../../../../services/muvicard.service'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../actions'

const schema = Yup.object().shape({
	password: Yup.string()
		.passwordCard()
		.required('Informe a nova senha'),
	passwordConfirmation: Yup.string()
		.equalTo(Yup.ref('password'), 'As senhas digitadas não conferem')
		.required('Informe a confirmação da nova senha'),
	codigo: Yup.string().required(
		'Informe o código, para a redefinição de senha'
	)
})

class MainComponent extends Component {
	constructor(props) {
		super(props)
		this.state = {
			step: 1,
			cardPersonId: '',
			hasValidToken: false
		}
	}

	prevStep = step => {
		if (step > 0) {
			this.setState({ step: step - 1 })
		}
	}

	nextStep = step => {
		if (step < 10) {
			this.setState({ step: step + 1 })
		}
	}

	componentDidMount() {
		MuvicardService.GetCardInfo().then(res => {
			if (res.success) {
				const { cardPersonId } = res.data
				this.setState({ cardPersonId })
			}
		})
	}

	render() {
		const { step, cardPersonId, hasValidToken } = this.state
		const {
			showLoading,
			hideLoading,
			user,
			toastSuccess,
			toastError
		} = this.props
		return (
			<React.Fragment>
				<Formik
					validationSchema={schema}
					initialValues={{
						password: '',
						passwordConfirmation: '',
						codigo: ''
					}}
					render={props => (
						<Form className="">
							{step === 1 && (
								<SendEmail
									cardPersonId={cardPersonId}
									nextStep={this.nextStep}
									step={step}
									showLoading={showLoading}
									hideLoading={hideLoading}
									user={user}
									toastSuccess={toastSuccess}
								/>
							)}
							{step === 2 && (
								<Code
									{...props}
									nextStep={this.nextStep}
									showLoading={showLoading}
									hideLoading={hideLoading}
									step={step}
									user={user}
									onValidToken={() =>
										this.setState({
											hasValidToken: true,
											step: step + 1
										})
									}
								/>
							)}
							{step === 3 && hasValidToken && (
								<PasswordComponent
									{...props}
									prevStep={this.prevStep}
									nextStep={this.nextStep}
									step={step}
								/>
							)}
							{step === 4 && hasValidToken && (
								<ConfirmPasswordComponent
									{...props}
									prevStep={this.prevStep}
									nextStep={this.nextStep}
									step={step}
									toastError={toastError}
								/>
							)}
							{/* <pre>{JSON.stringify(props, null, 2)}</pre> */}
						</Form>
					)}
				/>
			</React.Fragment>
		)
	}
}

const mapStateToProps = store => ({
	user: store.user
})
const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const Main = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MainComponent)
)

export default Main
